export default __webpack_public_path__ + "static/media/Cang Jei's Eleven Sacred Obscenities.55afd0f8.jpg";